import { useEffect } from 'react';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Tabs, Tab } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

import ParticipantApprovalTab from './components/tabs/EventParticipantsTabs/ParticipantApprovalTab/ParticipantApprovalTab';
import ParticipantTab from './components/tabs/EventParticipantsTabs/ParticipantTab/ParticipantTab';
import SelectedParticipantsTab from './components/tabs/EventParticipantsTabs/SelectedParticipantTab/SelectedParticipantsTab';
import ResourcePersonTab from './components/tabs/EventParticipantsTabs/ResourcePersonTab/ResourcePersonTab';
import { useSelector } from 'react-redux';

function EventParticipants() {
  const [activeTab, setActiveTab] = useState('selected_participant');
  const active_role = useSelector((state) => state.user?.user?.active_role);
  const [isAdmins, setIsAdmins] = useState(false);
  const { id } = useParams();
  const completed = useSelector((state) => state.event.event.completed);

  let render = null;
  switch (activeTab) {
    case 'participant_approval':
      render = <ParticipantApprovalTab id={id} />;
      break;
    case 'add_participant':
      render = <ParticipantTab id={id} />;
      break;
    case 'event.addResourcepersonAsParticipant':
      render = <ResourcePersonTab id={id} />;
      break;
    case 'selected_participant':
      render = <SelectedParticipantsTab />;
      break;
    default:
  }

  useEffect(() => {
    if (active_role === 'participant' || active_role === 'resource_person') {
      setIsAdmins(false);
    } else if (
      active_role === 'cd_admin' ||
      active_role === 'superuser' ||
      active_role === 'executive'
    ) {
      setIsAdmins(true);
    }
  }, [active_role]);

  return (
    <div className="card">
      {isAdmins && !completed ? (
        <div className="card-header">
          <Tabs
            id="uncontrolled-tab-example"
            className=""
            activeKey={activeTab}
            onSelect={(tab) => setActiveTab(tab)}>
            {[
              'selected_participant',
              'add_participant',
              'event.addResourcepersonAsParticipant',
              'participant_approval'
            ].map((tab, index) => {
              return <Tab key={index} eventKey={tab} title={<FormattedMessage id={tab} />}></Tab>;
            })}
          </Tabs>
        </div>
      ) : null}
      <div className="card-body pt-0">{render}</div>
    </div>
  );
}

export default EventParticipants;
